import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';

const DEFAULT_CONTENT = {
  name: '梅谷彩雲',
  nameKana: 'うめたに さいうん',
  bio: '16歳で出家得度し仏門に入門。大学時代には浜松市芸術祭で大賞を受賞し、その後16年間にわたり公立高校の国語科教諭・書道部顧問を務める。令和2年、長年の経験と修練を経て「虹嶺庵」を開業し、伝統書道を現代に発信し続けている。',
  timeline: [
    { year: '16歳', text: '出家得度し仏門に入門' },
    { year: '大学時代', text: '浜松市芸術祭にて大賞受賞' },
    { year: '16年間', text: '公立高校 国語科教諭・書道部顧問を務める' },
    { year: '令和2年', text: '「虹嶺庵」を開業' },
  ],
  credentials: [
    '虹嶺書法會・彩雲書道教室 主宰',
    '日蓮宗 教師',
    '毛筆・硬筆書写検定1級（文部科学省認定）',
    '各種展覧会 入賞・入選 多数',
  ],
  portraitUrl: `${process.env.PUBLIC_URL}/profile/profile.png`,
};

export default function ProfileSection() {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'siteContent', 'profile'), (snap) => {
      if (snap.exists()) {
        setContent({ ...DEFAULT_CONTENT, ...snap.data() });
      }
    });
    return unsubscribe;
  }, []);

  return (
    <section id="profile" className="pf-section pf-profile">
      <div className="pf-section__head">
        <p className="pf-section__eyebrow">PROFILE</p>
        <h2 className="pf-section__title">書家について</h2>
      </div>

      <div className="pf-profile__grid">
        <div className="pf-profile__portrait">
          <div className="pf-profile__portrait-frame">
            <img
              className="pf-profile__portrait-img"
              src={content.portraitUrl}
              alt={content.name}
            />
          </div>
        </div>

        <div className="pf-profile__body">
          <p className="pf-profile__name">{content.name} <span>{content.nameKana}</span></p>
          <p className="pf-profile__text">{content.bio}</p>

          <ul className="pf-profile__timeline">
            {content.timeline.map((t, i) => (
              <li key={`${t.year}-${i}`}>
                <span className="pf-profile__timeline-year">{t.year}</span>
                <span className="pf-profile__timeline-text">{t.text}</span>
              </li>
            ))}
          </ul>

          <h3 className="pf-profile__sub">資格・認定</h3>
          <ul className="pf-profile__credentials">
            {content.credentials.map((c, i) => <li key={i}>{c}</li>)}
          </ul>
        </div>
      </div>
    </section>
  );
}
